import React from 'react';

const socialLinks = [
    { href: 'http://linkedin.com/', img: '/images/logo1.png', alt: 'LinkedIn' },
    { href: 'https://github.com/quantum-cat-studio', img: '/images/github-logo.png', alt: 'GitHub' },
    { href: 'https://instagram.com/', img: '/images/logo3.png', alt: 'Instagram' },
    { href: 'https://www.youtube.com/', img: '/images/logo4.png', alt: 'YouTube Channel 1' },
    { href: 'https://www.google.com/', img: '/images/logo5.png', alt: 'Google' },
    { href: 'https://www.youtube.com/', img: '/images/logo6.png', alt: 'YouTube Channel 2' },
];

export default function SocialIcons() {
    return (
        <div className="container">
            <section className="social-icons-section">
                {socialLinks.map(({ href, img, alt }) => (
                    <a key={href} href={href} target="_blank" rel="noopener noreferrer">
                        <img src={img} alt={alt} width="64px" height="64px" className="social-icon" />
                    </a>
                ))}
            </section>
        </div>
    );
}
